import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {onSaveUser} from '../actions/UserActions';
import EditUser from '../components/UserEdit';

@connect(state => ({currentUser: state.auth.currentUser}), {onSaveUser})
export default class ProfileContainer extends Component {
    static propTypes = {
        currentUser: PropTypes.object,
        onSaveUser: PropTypes.func,
        onDeleteUser: PropTypes.func,
        history: PropTypes.object,
    };

    render() {
        const {currentUser, history} = this.props;
        return (
            <div className="page">
                <div className="page_contents">
                    <h1>{'Profile'}</h1>
                    <div className="card" style={{minHeight: 600}}>
                        <EditUser
                            initialValues={currentUser}
                            history={history}
                            id={currentUser.id}
                            onSubmit={this.props.onSaveUser}
                            header={currentUser.email}
                        />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/ProfileContainer.js